// import React from 'react'
import './contact.css'
import {MdOutlineEmail} from 'react-icons/md'
import { RiMessengerLine } from "react-icons/ri";
import { BsWhatsapp } from "react-icons/bs";
import emailjs from 'emailjs-com'
import React, { useRef } from "react";

const Contact = () => {
  const form=useRef();
  const sendEmail = (e) => {

    e.preventDefault();
    emailjs.sendForm('service_bs06z5r', 'template_4xmjpmh', form.current, 'vdwODb390GGNnbEsW')

  }
  
  return (
		<section id="contact">
			<h5>Get In Touch</h5>
			<h2>Contact Me</h2>
			<div className="container contact__container">
				<div className="contact__options">
					<article className="contact__option">
						<MdOutlineEmail className="contact__option-icon" />
						<h4>Email</h4>
						<h5>hkhankor@gmail.com</h5>
						<a href="mailto:hkhankor@gmail.com">
							Send a message{" "}
						</a>
					</article>
					<article className="contact__option">
						<RiMessengerLine className="contact__option-icon" />
						<h4>Messenger</h4>
						<h5>Hasan Tariq</h5>
						<a href="#">Send a message </a>
					</article>
					<article className="contact__option">
						<BsWhatsapp className="contact__option-icon" />
						<h4>WhatsApp</h4>
						<h5>03469413675</h5>
						<a
							href="https://api.whatsapp.com/send?phone+03469413675"
							
						>
							Send message{" "}
						</a>
					</article>
				</div>
				{/* End Of Contact Option */}
				<form ref={form} onSubmit={sendEmail}>
					<input
						type="text"
						name="name"
						placeholder="Your Full Name"
						required
					/>
					<input type="email" name="email" placeholder="Your Email" required />
					<textarea
						name="message"
						rows="7"
						placeholder="Your Message"
					></textarea>
					<button type="submit" className="btn btn-primary">
						Send Message
					</button>
				</form>
			</div>
		</section>
	);
}

export default Contact
